import { useMutation, useQueryClient } from 'react-query';
import { apiService } from '@/src/services/api-service';
import { HOME_MOVES_ENDPOINTS } from './endpoints';
import {
  UpdateMoveOutRequestBody,
  UpdateMoveOutSuccessResponse,
  UpdateMoveOutErrorResponse,
} from './types';

type UpdateMoveOutDateInput = {
  accountId: string;
  data: UpdateMoveOutRequestBody;
};

export function useUpdateMoveOutDateMutation() {
  const queryClient = useQueryClient();

  return useMutation<
    UpdateMoveOutSuccessResponse,
    UpdateMoveOutErrorResponse,
    UpdateMoveOutDateInput
  >(
    async ({ accountId, data }) => {
      const response = await apiService.put<UpdateMoveOutSuccessResponse>({
        url: HOME_MOVES_ENDPOINTS.updateMoveOutDate(accountId),
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response;
    },
    {
      onSuccess: (_, variables) => {
        queryClient.invalidateQueries(['home-moves', variables.accountId]);
      },
      onError: error => {
        console.error('Error updating move-out date:', error);
      },
    },
  );
}
